<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M192.63,199.63h-65.69c-3.87,0-7-3.13-7-7v-62.47c0-11-8.95-19.94-19.95-19.94s-19.95,8.95-19.95,19.94v62.47
		c0,3.87-3.13,7-7,7H7.37c-3.87,0-7-3.13-7-7V82.47c0-2.11,0.95-4.11,2.59-5.44l92.63-75.1c2.57-2.08,6.25-2.08,8.82,0l92.63,75.1
		c1.64,1.33,2.59,3.33,2.59,5.44v110.16C199.63,196.5,196.5,199.63,192.63,199.63z M133.94,185.63h51.69V85.81L100,16.38
		L14.37,85.81v99.82h51.68v-55.47c0-18.72,15.23-33.94,33.95-33.94s33.95,15.23,33.95,33.94V185.63z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
